// The layout toggle: an icon pair in the Segmented recipe's well (#12414 on
// the Agents page; #11635 Round 17 on the Investor Portals overview). One
// component for both pages, so they cannot drift: the well, 34×30 segments,
// the active one white on the well, a glyph in place of a label and the
// label in a tooltip.

import { type ReactNode } from "react";
import { Tooltip } from "@mui/material";

/** The well holding the segments, named for what it switches. */
export const LayoutToggle = ({
  label,
  children,
}: {
  label: string;
  children: ReactNode;
}) => (
  <div
    role="group"
    aria-label={label}
    className="inline-flex flex-none items-center gap-0.5 rounded-[11px] bg-[var(--fp-bg-well)] p-[4px]"
  >
    {children}
  </div>
);

/** One segment of the layout toggle: the Segmented recipe's active-white-on-
 *  the-well, with a glyph in place of a label and the label in a tooltip.
 *  A click on the active one is a no-op. */
export const LayoutButton = ({
  label,
  active,
  onClick,
  children,
}: {
  label: string;
  active: boolean;
  onClick: () => void;
  children: ReactNode;
}) => (
  <Tooltip title={label} placement="top" arrow>
    <button
      type="button"
      aria-label={label}
      aria-pressed={active}
      onClick={active ? undefined : onClick}
      className={`grid h-[30px] w-[34px] place-items-center rounded-[7px] transition-colors ${
        active
          ? "bg-[var(--fp-surface)] text-[var(--fp-ink)]"
          : "text-[var(--fp-ink-2)] hover:text-[var(--fp-ink)]"
      }`}
    >
      {children}
    </button>
  </Tooltip>
);
